module.exports = __webpack_public_path__ + "img/acfc5a6.png";